import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Typography } from '@bubble-ui/molecule-typography';
import { getDisplayName } from '@bubble-ui/util-get-display-name';
export { getDisplayName };
var getProp = (child, prop) => child.props[prop];
export var handleUnderlineIfLink = element => {
  return getDisplayName(element) === 'Link' && (element.props.isUnderlined !== undefined ? element.props.isUnderlined : true);
};
export var mapTypographyElement = (element, textStyleToken, textColorToken) => {
  var _getProp;
  return typeof element === 'string' && element.length > 0 || typeof element === 'number' ? /*#__PURE__*/React.createElement(Typography, {
    shrink: true,
    textToken: textStyleToken,
    colorToken: textColorToken
  }, element) : /*#__PURE__*/React.isValidElement(element) && ['Link', 'List', 'Typography'].includes(getDisplayName(element)) ? (/*#__PURE__*/React.cloneElement(element, _objectSpread({
    textToken: getProp(element, 'textToken') || textStyleToken,
    colorToken: getProp(element, 'colorToken') || textColorToken,
    isUnderlined: handleUnderlineIfLink(element)
  }, getDisplayName(element) === 'Typography' ? {
    shrink: (_getProp = getProp(element, 'shrink')) !== null && _getProp !== void 0 ? _getProp : true
  } : {}))) : element;
};
export var hasValidChildren = component => {
  if (/*#__PURE__*/React.isValidElement(component)) {
    return React.Children.toArray(getProp(component, 'children')).some(child => {
      return /*#__PURE__*/React.isValidElement(child) || Boolean(child);
    });
  }
  return false;
};
//# sourceMappingURL=utils.js.map